import React from 'react';
import { Spin } from 'antd';
import { Marker, Popup } from "react-leaflet";

import BaseMap from "./components/BaseMap";
import "./styles.css";


// Function to determine the map center coordinates
const getMapCenterCoordinates = (subProjects, defaultCenter) => {
    let centerLatitude = defaultCenter.latitude;
    let centerLongitude = defaultCenter.longitude;
  
    if (!subProjects) return { latitude: centerLatitude, longitude: centerLongitude };
  
    let foundLatitude = false;
    let foundLongitude = false;
  
    for (const subProject of subProjects) {
      if (!subProject?.progress) continue;
  
      // Handle progress as either an array or single object
      const progressItems = Array.isArray(subProject.progress) 
          ? subProject.progress 
          : [subProject.progress];
  
      for (const progressItem of progressItems) {
        if (!progressItem?.georeferenced_photos) continue;
  
        for (const photo of progressItem?.georeferenced_photos) {
          const hasLatitude = photo?.latitude !== undefined && photo?.latitude !== null;
          const hasLongitude = photo?.longitude !== undefined && photo?.longitude !== null;
  
          if (hasLatitude && !foundLatitude) {
            centerLatitude = photo?.latitude;
            foundLatitude = true;
          }
  
          if (hasLongitude && !foundLongitude) {
            centerLongitude = photo?.longitude;
            foundLongitude = true;
          }
  
          // If both coordinates have been found, return them
          if (foundLatitude && foundLongitude) {
            return { latitude: centerLatitude, longitude: centerLongitude };
          }
        }
      }
    }
  
    // Return the center coordinates (could be defaults or updated with available values)
    return { latitude: centerLatitude, longitude: centerLongitude };
  };
  
  
  
  

function SubProjectsMap({ subProjects, center, zoom, children }) {
    const renderMarker = (subProject) => {
        // Handle progress as either an array or single object
        const progressItems = Array.isArray(subProject?.progress) 
            ? subProject.progress 
            : subProject?.progress 
                ? [subProject.progress] 
                : [];
        return progressItems.map(progress => {
            return progress?.georeferenced_photos?.map(photo => {
                if (!photo || photo.latitude == null || photo.longitude == null) {
                    return null; // Skip rendering if data is missing
                }
                const { latitude, longitude } = photo;
                return (<Marker
                    key={`${photo.id}-marker`}
                    position={[latitude, longitude]}
        
                >
                    <Popup>
                        <section className="mapPopup">
                            <div className="popupHeader">
                                <h2>{subProject?.name || 'Sub Project'}</h2>
                            </div>
                            {photo?.image_url && (
                                <div className="fieldNote">
                                    <img src={photo.image_url} alt='Progress update' />
                                </div>
                            )}
                            {photo?.description && (
                                <div className="fieldNoteHeader">
                                    <p>{photo.description}</p>
                                </div>
                            )}
                        </section>
                    </Popup>
                </Marker>);
               
            });
        }).flat();
        
       
    }
    
    const { latitude: center_latitude, longitude: center_longitude } = getMapCenterCoordinates(subProjects, center);
    // const center_latitude = subProjects?.[0]?.progress?.[0]?.georeferenced_photos?.[0]?.latitude ?? center.latitude;
    // const center_longitude = subProjects?.[0]?.progress?.[0]?.georeferenced_photos?.[0]?.longitude ?? center.longitude;
    return (
        <div className="MapDashboard">
            <Spin spinning={false} tip="Loading data...">
                
                <BaseMap position={[center_latitude, center_longitude]} zoom={zoom}>
                    <>
                        {subProjects?.map((subProject) => (
                            <React.Fragment key={subProject?.id}>
                                {renderMarker(subProject)}
                            </React.Fragment>
                        ))}
                        {children}
                    </>
                </BaseMap>
            </Spin>
        </div>
    );
}

// Setting default props
SubProjectsMap.defaultProps = {
    subProjects: [],
    center: {
        latitude: -6.8153,
        longitude: 39.2796
    },
    zoom: 7,
};

export default SubProjectsMap;